<panel>
	<h1>{{ 'company.domains.change-domain-email.header' | translate }}</h1>
	<section>
		<custom-input [required]="true" [validation]="validationType.Email" [inputType]="inputTypeEnum.Text" [(value)]="requestModel.primaryEmail" [label]="'company.domains.change-domain-email.primary' | translate" />
		<custom-input [validation]="validationType.Email" [inputType]="inputTypeEnum.Text" [(value)]="requestModel.secondaryEmail" [label]="'company.domains.change-domain-email.secondary' | translate" />
	</section>
	<section>
		<button ghost (click)="close()" [ignoreValidation]="true">{{ 'general.close' | translate }}</button>
		<button #setDomainEmailButton
				(click)="setDomainEmail()"
				[label]="'company.domains.set-domain-email.submit' | translate"
				[labelSaved]="'company.domains.set-domain-email.saved' | translate">
		</button>
	</section>
</panel>
